import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const uploadDocument = (guid: string, formData: FormData, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any, source?: string): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/${guid}/documents?source=${source || 'ALFRESCO'}`,
		contentType: 'multipart/form-data',
		formData,
		onSuccess,
		onFailure,
	});
};
